import { useEffect } from 'react';

const MetaSEO = ({ title, description, keywords }) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | NexaAI Studio`;
    }

    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute('content', description);
      }
    }

    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      }
    }
  }, [title, description, keywords]);

  return null;
};

export default MetaSEO;
